import React from "react";
import MyNavbar from "../../../components/customer/myNavbar/MyNavbar";
import Footer from "../../../components/customer/footer/Footer";
import AllBlog from "../../../screens/customer/blogScreen/AllBlogs";
const Blog = () => {
    return(  
         <>
          <MyNavbar/>
         <AllBlog/>
          <Footer/>
        
         </>
  );
};

export default Blog;